import { render, staticRenderFns } from "./CommentField.vue?vue&type=template&id=29c6317d"
import script from "./CommentField.vue?vue&type=script&lang=js"
export * from "./CommentField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports